import { render } from "./TableCascader.vue?vue&type=template&id=660ed4d0&ts=true"
import script from "./TableCascader.vue?vue&type=script&lang=ts"
export * from "./TableCascader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__